var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"tabs",style:({marginTop: '-48px', marginLeft: '-30px'})},[_c('ul',[_c('li',{class:{'is-active': _vm.isActive === 'all'},on:{"click":function($event){return _vm.Tabs('all')}}},[_c('a',[_vm._v(_vm._s(_vm.$t("common.ທັງໝົດ")))])])])]),_c('ListShipment',{attrs:{"onclickEvent":_vm.onClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }